import Subnav from '@/components/Subnav';
import request from '@/utils/request';
import { getLocaleText } from '@/utils/utils';
import React, { Suspense, useEffect, useState } from 'react';
import { getLocale, history } from 'umi';

import styles from './index.less';

const Top = (props: any) => {
  const { word } = props;
  const accountId = localStorage.getItem('accountId')
    ? localStorage.getItem('accountId')
    : null;
  const [days, setDays] = useState<any>(0);

  useEffect(() => {
    const init = async () => {
      const activityUrl = `${process.env.cmsUrl}/bi-api/activities-api/activity_info`;
      const activityRes = await request.get(activityUrl);
      if (activityRes.data) {
        const dayUrl = `${
          process.env.cmsUrl
        }/bi-api/activities-api/vod_days?orgSpid=${
          process.env.orgSpid
        }&siteId=${process.env.siteId}&userId=${accountId}&activityBeginTime=${
          activityRes.data?.activityStartTime
        }&activityEndTime=${
          activityRes.data?.activityEndTime
        }&localz=${getLocale().replace(/-/gi, '_')}`;
        const dayRes = await request.get(dayUrl);
        setDays(dayRes?.data?.days);
        const detailUrl = `${process.env.cmsUrl}/bi-api/activities-api/vod_num?orgSpid=${process.env.orgSpid}&siteId=${process.env.siteId}&userId=${accountId}`;
      } else {
        setDays(null);
      }
    };
    init();
  }, []);
  return (
    <div className={styles.top}>
      <div
        className={styles.top_home}
        onClick={() => {
          history.push({
            pathname: '/home',
          });
        }}
      >
        <img src={require('@/assets/images/index/home.png')} alt="" />
      </div>
      <div className={styles.search}>
        <Subnav
          word={word}
          // categoryObj={itemData.find(
          //   (item: { layout: string }) =>
          //     item.layout === 'app_screening_lable', //筛选 搜索元素
          // )}
        />
      </div>
      {days && (
        <div className={styles.days}>
          {`${getLocaleText('home.page.lodin')}`}
          <span className={styles.num}>{days}</span>
          {getLocaleText('home.page.day')}
        </div>
      )}
      <div className={styles.record}>
        <span
          onClick={() => {
            history.push({
              pathname: '/collect',
              state: { type: 'view' },
            });
          }}
        >
          {getLocaleText('collect.page.viewRecord')}
        </span>
        <span
          onClick={() => {
            history.push({
              pathname: '/collect',
              state: { type: 'collect' },
            });
          }}
        >
          {getLocaleText('collect.page.myCollect')}
        </span>
      </div>
      <div
        className={styles.top_profile}
        onClick={() => {
          history.push({
            pathname: '/profile',
          });
        }}
      >
        <img src={require('@/assets/images/index/profile.png')} alt="" />
      </div>
    </div>
  );
};
export default Top;
